module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "shipping-address"
    }
  }, [_c('div', {
    staticClass: "title semibold mb-4"
  }, [_vm._v("Billing Information")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "First Name"
    },
    model: {
      value: (_vm.user.billing_address.first_name),
      callback: function($$v) {
        _vm.$set(_vm.user.billing_address, "first_name", $$v)
      },
      expression: "user.billing_address.first_name"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Last Name"
    },
    model: {
      value: (_vm.user.billing_address.last_name),
      callback: function($$v) {
        _vm.$set(_vm.user.billing_address, "last_name", $$v)
      },
      expression: "user.billing_address.last_name"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Company Name"
    },
    model: {
      value: (_vm.user.billing_address.company),
      callback: function($$v) {
        _vm.$set(_vm.user.billing_address, "company", $$v)
      },
      expression: "user.billing_address.company"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Phone Number"
    },
    model: {
      value: (_vm.user.billing_address.phone),
      callback: function($$v) {
        _vm.$set(_vm.user.billing_address, "phone", $$v)
      },
      expression: "user.billing_address.phone"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Email"
    },
    model: {
      value: (_vm.user.billing_address.email),
      callback: function($$v) {
        _vm.$set(_vm.user.billing_address, "email", $$v)
      },
      expression: "user.billing_address.email"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Street 1"
    },
    model: {
      value: (_vm.user.billing_address.street1),
      callback: function($$v) {
        _vm.$set(_vm.user.billing_address, "street1", $$v)
      },
      expression: "user.billing_address.street1"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Street 2"
    },
    model: {
      value: (_vm.user.billing_address.street2),
      callback: function($$v) {
        _vm.$set(_vm.user.billing_address, "street2", $$v)
      },
      expression: "user.billing_address.street2"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "City"
    },
    model: {
      value: (_vm.user.billing_address.city),
      callback: function($$v) {
        _vm.$set(_vm.user.billing_address, "city", $$v)
      },
      expression: "user.billing_address.city"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "State"
    },
    model: {
      value: (_vm.user.billing_address.state),
      callback: function($$v) {
        _vm.$set(_vm.user.billing_address, "state", $$v)
      },
      expression: "user.billing_address.state"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "ZIP"
    },
    model: {
      value: (_vm.user.billing_address.zip),
      callback: function($$v) {
        _vm.$set(_vm.user.billing_address, "zip", $$v)
      },
      expression: "user.billing_address.zip"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Country"
    },
    model: {
      value: (_vm.user.billing_address.country),
      callback: function($$v) {
        _vm.$set(_vm.user.billing_address, "country", $$v)
      },
      expression: "user.billing_address.country"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-699f69fe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/users/billing-address.vue
// module id = 668
// module chunks = 1